import {createContext} from 'react'
import {ModalOnHoldHandler} from 'types'

export const ModalOnHoldContext = createContext<ModalOnHoldHandler | undefined>(
  undefined,
)
